export const userConstants = {
  LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
  LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
  LOGIN_ERROR: 'USERS_LOGIN_ERROR',
  LOGOUT: 'USER_LOGOUT',
  ME_INFO_REQUEST: 'ME_INFO_REQUEST',
  ME_INFO_SUCCESS: 'ME_INFO_SUCCESS',
  ME_INFO_ERROR: 'ME_INFO_ERROR',
};
